import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ConfigurationApiService } from '../../generated/api/configuration/configuration.service';

@Component({
    selector: 'extern-footer',
    templateUrl: './extern-footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExternFooterComponent {

    footerTextCopyright = '';

    urlFooterWkvPortal = '';

    urlFooterImpressum = '';

    urlFooterDatenschutz = '';

    urlFooterHilfe = '';

    constructor(
        private readonly configurationApiService: ConfigurationApiService
    ) {
        this.configurationApiService.getConfiguration().subscribe(configuration => {
            this.footerTextCopyright = configuration.footerTextCopyright;
            this.urlFooterWkvPortal = configuration.urlFooterWkvPortal;
            this.urlFooterImpressum = configuration.urlFooterImpressum;
            this.urlFooterDatenschutz = configuration.urlFooterDatenschutz;
            this.urlFooterHilfe = configuration.urlHilfe;
        });
    }

}
